var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddQuantity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:2px}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_185",
    "data-name": "Group 185",
    transform: "translate(-987 -825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_8",
    d: "M0 0H18V18H0z",
    "data-name": "Rectangle 8",
    transform: "translate(987 825)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_183",
    "data-name": "Group 183",
    transform: "translate(993.065 831.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8",
    d: "M0 0h5.87",
    className: "prefix__cls-1",
    "data-name": "Path 8",
    transform: "rotate(180 2.935 1.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_75",
    d: "M0 0h5.87",
    className: "prefix__cls-1",
    "data-name": "Path 75",
    transform: "rotate(90 1.468 1.468)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuantity);
export default __webpack_public_path__ + "static/media/add-quantity.0e72a69cbea60753aa6d3cc9195fe1eb.svg";
export { ForwardRef as ReactComponent };